export const displaySize = 'sm';

export const firestoreCollections = {
    houses: 'houses',
    news: 'news',
    banners: 'banners',
    albums: 'albums',
};